import { AuthGuard } from './auth.guard';
import { MdToHtmlPipe } from './md-to-html.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { ClickOutsideModule } from 'ng-click-outside';
import { ModalModule } from '../modal/modal.module';

import { CommonLibModule } from 'common-lib';

import { TabMenuComponent } from './tab-menu/tab-menu.component';
import { HeaderComponent } from './header/header.component';
import { FJHeaderComponent } from './fj-header/fj-header.component';
import { FooterComponent } from './footer/footer.component';
import { StoryComponent } from './story/story.component';
import { FeatComponent } from './feat/feat.component';
import { FeatCardComponent } from './feat-card/feat-card.component';
import { StoryManyComponent } from './story-many/story-many.component';
import { JobComponent } from './job/job.component';
import { CompanyComponent } from './company/company.component';
import { CompanyItemComponent } from './company-item/company-item.component';
import { JobItemComponent } from './job-item/job-item.component';
import { TabHeaderComponent } from './tab-header/tab-header.component';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NoAuthGuard } from './no-auth.guard';
import { ToastrModule } from 'ngx-toastr';
import { ReversePipe } from './reverse.pipe';
import { SetMetaComponent } from './set-meta/set-meta.component';
import { DateSelectComponent } from './date-select/date-select.component';
import { BusinessHeaderComponent } from './business-header/business-header.component';
import { BusinessFooterComponent } from './business-footer/business-footer.component';
import { AuthPopupComponent } from './auth-popup/auth-popup.component';
import { PersonalInfoComponent } from '../profile/personal-info/personal-info.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    CommonLibModule,
    NgbModule,
    NgbDropdownModule,
    ToastrModule.forRoot(),
    LazyLoadImageModule,
    ClickOutsideModule,
    ModalModule,
  ],
  declarations: [
    TabMenuComponent,
    HeaderComponent,
    FJHeaderComponent,
    FooterComponent,
    StoryComponent,
    FeatComponent,
    FeatCardComponent,
    StoryManyComponent,
    JobComponent,
    CompanyComponent,
    CompanyItemComponent,
    JobItemComponent,
    TabHeaderComponent,
    MdToHtmlPipe,
    ReversePipe,
    SetMetaComponent,
    DateSelectComponent,
    BusinessHeaderComponent,
    BusinessFooterComponent,
    AuthPopupComponent,
    PersonalInfoComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    CommonLibModule,
    FooterComponent,
    HeaderComponent,
    FJHeaderComponent,
    CompanyComponent,
    CompanyItemComponent,
    JobComponent,
    JobItemComponent,
    StoryComponent,
    FeatComponent,
    FeatCardComponent,
    StoryManyComponent,
    TabHeaderComponent,
    TabMenuComponent,
    ToastrModule,
    MdToHtmlPipe,
    ReversePipe,
    SetMetaComponent,
    LazyLoadImageModule,
    DateSelectComponent,
    BusinessFooterComponent,
    BusinessHeaderComponent,
    AuthPopupComponent,
    PersonalInfoComponent,
  ],
  providers: [AuthGuard, NoAuthGuard],
})
export class SharedModule {}
